<app-vault-module-shell
  moduleLabel="Respaldo Externo"
  [accessDenied]="accessDenied()"
  [loadError]="loadError()"
  [loadErrorTitle]="loadErrorTitle()"
>
<section class="cloud">
  <app-page-header
    title="Respaldo Externo"
    subtitle="Monitorea sincronización con cloud, daemon y logs."
    icon="Cloud"
    [actions]="headerActions()"
    (actionClick)="onHeaderAction($event)"
  />

  @if (error()) {
    <app-vault-page-alert
      type="error"
      title="Error"
      [message]="error()"
      (closed)="error.set(null)"
    />
  }
  @if (info()) {
    <app-vault-page-alert
      type="info"
      title="Aviso"
      [message]="info()"
      (closed)="info.set(null)"
    />
  }

  <div class="cloud__cards">
    <article><h4>Locales</h4><p>{{ totalLocal() }}</p></article>
    <article><h4>Cloud</h4><p>{{ totalCloud() }}</p></article>
    <article><h4>Sincronizados</h4><p>{{ synced() }}</p></article>
    <article><h4>Pendientes</h4><p>{{ missing() }}</p></article>
  </div>

  <section class="cloud__daemon">
    <div>
      <h3>Daemon automático</h3>
      <p>
        Estado:
        @if (daemonRunning() === true) {
          <lib-badge text="En ejecución" variant="success" size="small" />
          @if (daemonPid()) {
            <span>PID {{ daemonPid() }}</span>
          }
        } @else if (daemonRunning() === false) {
          <lib-badge text="Detenido" variant="neutral" size="small" />
        } @else {
          <lib-badge text="Sin información" variant="warning" size="small" />
        }
      </p>
    </div>
    <div class="cloud__actions">
      <lib-button variant="secondary" (clicked)="startDaemon()" [disabled]="daemonRunning() === true">Iniciar</lib-button>
      <lib-button variant="secondary" (clicked)="stopDaemon()" [disabled]="daemonRunning() !== true">Detener</lib-button>
      <lib-button variant="secondary" (clicked)="loadDaemonStats()">Stats</lib-button>
      <lib-button variant="secondary" (clicked)="loadDaemonLogs()">Logs</lib-button>
    </div>
  </section>

  @if (daemonStats()) {
    <section class="cloud__panel">
      <h4>Estadísticas daemon</h4>
      <pre>{{ daemonStats() }}</pre>
    </section>
  }
  @if (daemonLogs().length > 0) {
    <section class="cloud__panel">
      <h4>Últimos logs</h4>
      <pre>{{ daemonLogs().join('\n') }}</pre>
    </section>
  }

  @if (rows().length > 0) {
    <div class="cloud__table-head">
      <lib-button variant="secondary" (clicked)="selectAllMissing(true)">Seleccionar pendientes</lib-button>
      <lib-button variant="secondary" (clicked)="selectAllMissing(false)">Limpiar selección</lib-button>
    </div>
    <div class="cloud__table">
      @for (row of rows(); track row.local_file.relative_path) {
        <article class="cloud__row">
          <lib-checkbox
            [checked]="!!selected()[row.local_file.relative_path]"
            [disabled]="row.in_cloud"
            (checkedChange)="toggleSelect(row.local_file.relative_path, $event)"
            label=""
          />
          <div>
            <strong>{{ row.local_file.project_name }}</strong>
            <p>{{ row.local_file.relative_path }}</p>
          </div>
          <span>{{ row.sizeLabel }}</span>
          <lib-badge [text]="row.statusLabel" [variant]="row.in_cloud ? 'success' : 'warning'" size="small" />
        </article>
      }
    </div>
  } @else if (!loading()) {
    <lib-empty icon="Cloud" message="Sin archivos para sincronizar" />
  }
</section>
</app-vault-module-shell>
